// extracted by mini-css-extract-plugin
export default {"bgContainer":"secondStep_bgContainer__KbAUF","mainContainerBg":"secondStep_mainContainerBg__R3vtb","QrContainer":"secondStep_QrContainer__Cqo1E"};